import Apptimize from '@apptimize/apptimize-web-sdk'
import { essLinkDisabledClients } from 'const/account/clients'

const getEssLinkDisabledClients = () =>
  Apptimize.getStringArray('essLinkDisabledClients', [
    ...essLinkDisabledClients
  ])

const isAccountLinkDisabledForAClient = (clientId: string) => {
  const disabledClients = getEssLinkDisabledClients()
  return disabledClients.includes(clientId)
}

export { essLinkDisabledClients, getEssLinkDisabledClients }
export default isAccountLinkDisabledForAClient
